import Card from "components/card";
import CardMenu from "components/card/CardMenu";
import Switch from "components/switch";
import React, {useState} from "react";
import CustomPagination from "../../../../components/CustomPagination/CustomPagination";
import axios from "axios";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import useAsyncEffect from "use-async-effect";

function UserAppNotifications() {

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();

    let [notificationInfos, setNotificationInfos] = useState([])
    let [isLoading, setIsLoading] = useState(true)
    let [selectedValue, setSelectedValue] = useState("Device")

    const [pg, setpg] = useState(0);
    const [rpg, setrpg] = useState(6);

    function handleChangePage(event, newpage) {
        setpg(newpage);
    }

    function handleChangeRowsPerPage(event) {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    function getUserNotifications(filterSelected) {


        //var url = CROMPTON_URL + "notifications/getByCategory/" + decryptedValueuname + "/" + filterSelected.toLowerCase()
        var url = CROMPTON_URL + "notifications/V2/getByCategory" + "/" + filterSelected.toLowerCase()

        axios({
            method: "GET", url: url, headers: {
                Authorization: decryptedValue,
            }

        }).then((res) => {
            //console.log(res.data)
            setNotificationInfos(res.data)
            setIsLoading(false)


        }).catch((error) => {
            //console.log(error)
            if (error.response.data.status === "401" || error.response.data.status === "403") {
                handleLogOut();
            }
        })

    }

    useAsyncEffect(async () => {

            getUserNotifications(selectedValue)
        }, [""]
    );

    function handleNotificationFilterSelectDropDown() {
        const selectBox = document.getElementById("notificationFilterSelectBox")
        selectedValue = selectBox.options[selectBox.selectedIndex].value
        setSelectedValue(selectBox.options[selectBox.selectedIndex].value)

        getUserNotifications(selectedValue)
        //getInActiveDevicesTrend(selectedValue.toLowerCase())
    }

    return (
        <Card extra={"w-full h-full p-3"}>
            <div className="mb-8 w-full">
                <div className="flex justify-between">
                    <h4 className="text-xl font-bold text-navy-700 dark:text-white">
                        App Notifications
                    </h4>
                    <select id="notificationFilterSelectBox" onChange={handleNotificationFilterSelectDropDown}
                            className="mb-3 flex items-center justify-center text-sm font-bold text-gray-600 me-2 hover:cursor-pointer dark:!bg-navy-800 dark:text-white">
                        <option value="device">Device</option>
                        <option value="home">Home</option>
                        <option value="room">Room</option>
                        <option value="app">App</option>
                        <option value="schedule">Schedule</option>
                    </select>
                </div>
                <p className="mt-2 text-base text-gray-600">
                    Here you can find notifications.
                </p>
                {/* <CardMenu />*/}
            </div>
            <div className="flex flex-col">
                {/* the custom checkbox desing added in src/index.js */}
                {
                    notificationInfos.slice(pg * rpg, pg * rpg + rpg).map((Val) => {
                        return (
                            Val.isRead === true ?
                                <div
                                    className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                                    <div className="flex justify-between">
                                        <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
                                            {Val.title}
                                        </p>
                                        <p className="mb-1 text-left text-xs text-gray-900 dark:text-white">
                                            {Val.date}
                                        </p>
                                    </div>
                                    <p className="font-base text-left text-xs text-gray-900 dark:text-white">
                                        {Val.information}
                                    </p>
                                    <br/>
                                </div> :
                                <div
                                    className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                                    <div className="flex justify-between">
                                        <p className="mb-1 text-left text-base font-bold text-gray-600 dark:text-gray-600">
                                            {Val.title}
                                        </p>
                                        <p className="mb-1 text-left text-xs text-gray-900 dark:text-white">
                                            {Val.date}
                                        </p>
                                    </div>
                                    <p className="font-base text-left text-xs text-gray-900 dark:text-white">
                                        {Val.information}
                                    </p>
                                    <br/>
                                </div>
                        )

                    })
                }


                {/*<div className="mt-4 flex items-center gap-3">
          <Switch id="switch2" />
          <label
            for="checkbox2"
            className="text-base font-medium text-navy-700 dark:text-white"
          >
            Buyer review notifications
          </label>
        </div>

        <div className="mt-4 flex items-center gap-3">
          <Switch id="switch3" />
          <label
            for="checkbox3"
            className="text-base font-medium text-navy-700 dark:text-white"
          >
            Rating reminders notifications
          </label>
        </div>

        <div className="mt-4 flex items-center gap-3">
          <Switch id="switch4" />
          <label
            for="checkbox4"
            className="text-base font-medium text-navy-700 dark:text-white"
          >
            Meetups near you notifications
          </label>
        </div>

        <div className="mt-4 flex items-center gap-3">
          <Switch id="switch5" />
          <label
            for="checkbox5"
            className="text-base font-medium text-navy-700 dark:text-white"
          >
            Company news notifications
          </label>
        </div>

        <div className="mt-4 flex items-center gap-3">
          <Switch id="switch6" />
          <label
            for="checkbox6"
            className="text-base font-medium text-navy-700 dark:text-white"
          >
            New launches and projects
          </label>
        </div>
        <div className="mt-4 flex items-center gap-3">
          <Switch id="switch7" />
          <label
            for="checkbox7"
            className="text-base font-medium text-navy-700 dark:text-white"
          >
            Monthly product changes
          </label>
        </div>
        <div className="mt-4 flex items-center gap-3">
          <Switch id="switch8" />
          <label
            for="checkbox8"
            className="text-base font-medium text-navy-700 dark:text-white"
          >
            Subscribe to newsletter
          </label>
        </div>
        <div className="mt-4 flex items-center gap-3">
          <Switch id="switch8" />
          <label
            for="checkbox8"
            className="text-base font-medium text-navy-700 dark:text-white"
          >
            Email me when someone follows me
          </label>
        </div>*/}
            </div>

            <CustomPagination
                rowsPerPageOptions={[6, 10, 15]}
                component="div"
                count={notificationInfos.length}
                rowsPerPage={rpg}
                page={pg}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Card>
    );
}

export default UserAppNotifications;
